import { twMerge } from "@/utils/twMerge";

import type { DOMOutputSpec } from "@tiptap/pm/model";

export const CORCA_TOOLTIP_TRIGGER_CLASS = "corca-tooltip-trigger group/tooltip relative";

type TooltipBoxOptions = {
  class?: string;
  attrs?: Record<string, string>;
};

export function tooltipBoxSpec(
  content: string,
  { class: className, attrs }: TooltipBoxOptions = {},
): DOMOutputSpec {
  const decorative = attrs?.["aria-hidden"] === "true";
  const boxAttrs = {
    ...(decorative ? {} : { role: "tooltip" }),
    contenteditable: "false",
    ...attrs,
    class: twMerge(
      "corca-tooltip-box",
      "font-normal indent-0 pointer-events-none",
      "absolute bottom-full left-1/2 -translate-x-1/2 mb-[5px]",
      "opacity-0 transition-opacity duration-[120ms]",
      "[@media(hover:hover)]:group-hover/tooltip:opacity-100 [@media(hover:hover)]:group-hover/tooltip:delay-100",
      "group-focus-within/tooltip:opacity-100",
      "w-[max-content] max-w-[250px] bg-black/70 dark:bg-gray-700/80 backdrop-blur-xs text-white text-xs rounded-lg px-2.5 py-2.5 tracking-tight z-50",
      className,
    ),
  };

  return ["span", { ...boxAttrs, "data-tooltip": content }];
}

type TooltipSpecProps = {
  content: string;
  class?: string;
  tooltipClass?: string;
  attrs?: Record<string, string>;
  tooltipAttrs?: Record<string, string>;
};

export function tooltipSpec(
  { content, class: className, tooltipClass, attrs, tooltipAttrs }: TooltipSpecProps,
  ...children: (DOMOutputSpec | string)[]
): DOMOutputSpec {
  return [
    "span",
    {
      class: twMerge(CORCA_TOOLTIP_TRIGGER_CLASS, className),
      ...attrs,
    },
    ...children,
    tooltipBoxSpec(content, { class: tooltipClass, attrs: tooltipAttrs }),
  ];
}
